"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _mapData = require("../utils/map-data");

var _default = {
  fromApi: function fromApi(data) {
    return (0, _mapData.deeply)(data, function (obj) {
      return _lodash.default.mapKeys(obj, function (value, key) {
        return _lodash.default.camelCase(key);
      });
    });
  },
  toApi: function toApi(data) {
    return (0, _mapData.deeply)(data, function (obj) {
      return _lodash.default.mapKeys(obj, function (value, key) {
        return _lodash.default.snakeCase(key);
      });
    });
  }
};
exports.default = _default;